import React from 'react';
import { AtomIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-blue px-4 py-24 text-center text-white" data-id="element-61" data-mp="3n4wb455willk">
      <Reveal className="mx-auto max-w-3xl" data-id="element-62" data-mp="3s2pjn4uofrp0">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-teal/30 text-brand-orange" data-id="element-63" data-mp="vlaa3b27tdf">
          <AtomIcon className="h-7 w-7" aria-hidden="true" data-id="element-64" data-mp="2zejvs98btmky" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-65" data-mp="34cbw9rn1eh0r">¿List@ para recuperar tu tiempo?</h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-66" data-mp="39byao4elq3b5">
          Únete a los docentes que ya enseñan Física y Química sin pasar horas preparando material.
        </p>
        <CTAButton variant="white" className="mt-9 px-10 py-5 text-lg" data-id="element-67" data-mp="2gn0s006ha4hv">
          QUIERO EL PACK FÍSICA Y QUÍMICA LISTA
        </CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-68" data-mp="2ll2dssvaghx1">Descarga instantánea · Garantía de 7 días · Pago único de 19 USD</p>
      </Reveal>
    </section>;
}